export default __webpack_public_path__ + "static/media/low-priority.1a7fc2b1.svg";